module.exports = __webpack_public_path__ + "static/video_prev-bad85f8f1aad11d0704e68c753dcee7a.png";